import { useState, useEffect, createContext } from 'react';
import profilesData from '../data/profiles/profiles.json';

export type BeneficiariesState = {
    profiles: Array<any>,
    add: (profile: any) => void;
};

export const BeneficiariesStore = createContext<BeneficiariesState>({profiles: [], add: (profile) => {}});

const { Provider } = BeneficiariesStore;

export const BeneficiariesProvider = ({ children }: any) => {
  const [profiles, setProfiles] = useState<Array<any>>([]);

  useEffect(() => {
    const bProfiles = profilesData.data.filter((profile) => profile.id !== '1');
    setProfiles(bProfiles);
  }, []);

  const add = (profile: any) => {
    profile.id = profiles.length + 1;
    setProfiles([...profiles, profile]);
  };

  return <Provider value={{profiles, add}}>{children}</Provider>;
}
